<template>
  <!-- 本地查询 -->
  <div>
    <div class="localQuery" :class="{ magnify: isMagnify }" v-if="authority">
      <!-- 放大缩小 -->
      <div
        class="magnify_box"
        :title="!isMagnify ? '全屏' : '退出全屏'"
        @click="switchMagnify"
      >
        <i class="iconfont icon-quanping" v-if="!isMagnify"></i>
        <i
          class="iconfont icon-suoxiaotuichuquanpingshouhui suoxiao"
          v-else
        ></i>
      </div>
      <div class="head">
        <el-form :model="form" :rules="rules" ref="form">
          <!-- 时间/链接 -->
          <div class="type_box time_box">
            <el-form-item class="form_item" label="发表时间:">
              <div class="date_box">
                <el-date-picker
                  v-model="form.date"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  align="right"
                >
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item
              style="margin-left:15px;"
              class="form_item"
              label="入库时间:"
            >
              <div class="date_box">
                <el-date-picker
                  v-model="form.uDate"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  align="right"
                >
                </el-date-picker>
              </div>
            </el-form-item>
            <!-- 搜索按钮 -->
            <el-button
              type="primary"
              class="btn"
              @click="search"
              v-if="!conditionShow"
              >搜索</el-button
            >
          </div>

          <div class="input_box" v-if="conditionShow">
            <!-- 一级域名 -->
            <el-form-item class="form_item" label="一级域名:">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 8 }"
                placeholder="请输入一级域名（多个一级域名请用逗号隔开）"
                v-model="form.domain"
              >
              </el-input>
            </el-form-item>
            <!-- taskID -->
            <el-form-item class="form_item" label="taskID:">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 8 }"
                placeholder="请输入taskID（多个taskID请用逗号隔开）"
                v-model="form.taskId"
              >
              </el-input>
            </el-form-item>
            <!-- siteID -->
            <el-form-item class="form_item" label="siteID:">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 8 }"
                placeholder="请输入一级域名（多个一级域名请用逗号隔开）"
                v-model="form.siteId"
              >
              </el-input>
            </el-form-item>
          </div>

          <!-- 关键词、排除关键词 -->
          <div class="type_box word_box" v-if="conditionShow">
            <!-- 关键词 -->
            <el-form-item class="form_item" label="关键词:">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 8 }"
                placeholder="请输入关键词"
                v-model="form.keyword"
              >
              </el-input>
            </el-form-item>
            <!-- 排除词 -->
            <el-form-item class="form_item" label="排除词:">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 8 }"
                placeholder="请输入排除词"
                v-model="form.noKeyword"
              >
              </el-input>
            </el-form-item>
          </div>

          <!-- 链接 -->
          <div class="formInput_box" v-if="conditionShow">
            <el-form-item class="form_item form_url" label="链接:">
              <div class="url_input">
                <el-input
                  v-model="form.url"
                  placeholder="请输入链接"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item class="form_item form_url" label="站点名:">
              <div class="url_input">
                <el-input
                  v-model="form.siteName"
                  placeholder="请输入站点名"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item class="form_item form_url" label="作者:">
              <div class="url_input">
                <el-input
                  v-model="form.authorName"
                  placeholder="请输入作者"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
          </div>
          <!-- 信源 -->
          <div v-if="conditionShow">
            <el-form-item class="form_item" label="信源:" prop="siteTypes">
              <div class="checkboxDom">
                <el-checkbox
                  class="checkAll"
                  :indeterminate="!checkAll"
                  v-model="checkAll"
                  @change="selectAll"
                  >全选</el-checkbox
                >
                <el-checkbox-group
                  v-model="form.siteTypes"
                  @change="selectSomeSource"
                >
                  <el-checkbox
                    v-for="source in sourceList"
                    :label="source.id"
                    :key="source.id"
                    >{{ source.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>
          </div>
          <!-- 文章类型 -->
          <div class="type_box" v-if="conditionShow">
            <el-form-item class="form_item" label="文章类型:">
              <div class="checkboxDom">
                <el-checkbox-group v-model="form.artTypes">
                  <el-checkbox label="1">原创</el-checkbox>
                  <el-checkbox label="2">转发</el-checkbox>
                  <el-checkbox label="3">评论</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <!-- 搜索按钮 -->
            <el-button type="primary" class="btn" @click="search"
              >搜索</el-button
            >
          </div>
        </el-form>
        <a
          href="javascript:;"
          class="show_btn"
          @click="conditionShow = !conditionShow"
        >
          {{ conditionShow ? "收起" : "展开"
          }}<i
            class="iconfont icon-xiangxiajiantouxiao"
            :class="{ icon: conditionShow }"
          ></i>
        </a>
      </div>
      <!-- tabber -->
      <!-- <ul class='tab'>
                <li v-for='(item,i) in source' :key ='i'>
                    <a href="javascript:;" :class='{active:tabIndex == i}'>
                        {{siteObj[item.site]}}（{{changNum(item.value)}}）
                    </a>
                </li>
            </ul> -->
      <!-- 文章列表 -->
      <div class="list_box" ref="list" v-load="loading">
        <div v-for="(item, index) in list" :key="index">
          <div class="num" :class="{ weibo_num: item.site_type == 'weibo' }">
            {{ index + 1 }}
          </div>
          <div class="art" :class="{ weibo_art: item.site_type == 'weibo' }">
            <div class="head_img" v-if="item.site_type == 'weibo'">
              <img :src="item.author.headimg_url" alt="" />
            </div>
            <div :class="{ weibo_style: item.site_type == 'weibo' }">
              <div class="art_det">
                <!-- 微博名 -->
                <div class="title" v-if="item.site_type == 'weibo'">
                  <!-- 1：原创、2：转发、3：评论 -->
                  <span class="tag tag2" v-if="item.wtype == 1"
                    ><span>原创</span></span
                  >
                  <span class="tag" v-if="item.wtype == 2"
                    ><span>转发</span></span
                  >
                  <span class="tag tag3" v-if="item.wtype == 3"
                    ><span>评论</span></span
                  >
                  {{ item.author.name }}
                </div>
                <div class="title" v-html="item.title" v-else></div>
                <div class="content">
                  <div
                    :class="{ hidden_content: !item.show }"
                    v-html="$getEmtion(item.summary || item.content)"
                    @click="openDet(item)"
                  ></div>
                  <a
                    href="javascript:;"
                    class="more_btn"
                    @click="lookMore(item)"
                    v-if="item.wtype != 2"
                  >
                    {{ item.show ? "收起更多" : "查看更多"
                    }}<i
                      class="iconfont icon-xiangxiajiantouxiao"
                      :class="{ icon: item.show }"
                    ></i>
                  </a>
                </div>
                <!-- 微博转发的内容 -->
                <div
                  class="content weibo_content"
                  v-if="item.site_type == 'weibo' && item.wtype == 2"
                >
                  <div
                    :class="{ hidden_content: !item.show }"
                    v-html="$getEmtion(item.weibo.recontent)"
                    @click="openDet(item)"
                  ></div>
                  <a
                    href="javascript:;"
                    class="more_btn"
                    @click="lookMore(item)"
                  >
                    {{ item.show ? "收起更多" : "查看更多"
                    }}<i
                      class="iconfont icon-xiangxiajiantouxiao"
                      :class="{ icon: item.show }"
                    ></i>
                  </a>
                </div>
                <ul class="img_box" v-if="item.picUrls">
                  <li v-for="(img, i) in item.picUrls" :key="i">
                    <img :src="img" alt="" />
                  </li>
                </ul>
                <ul class="fn_box">
                  <li>
                    <a :href="item.url" target="_bank">原文链接</a>
                  </li>
                  <li>
                    <i
                      style="color: #f00"
                      class="iconfont icon-shangxin"
                      v-if="item.sentiment == -1"
                    ></i>
                    <i
                      style="font-size: 17px"
                      class="iconfont icon-biaoqing"
                      v-if="item.sentiment == 0"
                    ></i>
                    <i
                      style="color: #0f0"
                      class="iconfont icon-Smile"
                      v-if="item.sentiment == 1"
                    ></i>
                  </li>
                  <li><span>来源：</span>{{ item.site_name }}</li>
                  <li v-if="item.site_type != 'weibo' && item.author.name">
                    <span>作者：</span>{{ item.author.name }}
                  </li>
                  <li><span>发表时间：</span>{{ time(String(item.ctime)) }}</li>
                  <li><span>入库时间：</span>{{ time(String(item.utime)) }}</li>
                  <li v-if="item.keywords && item.keywords.length != 0">
                    <span>keywords：</span>{{ item.keywords.join("，") }}
                  </li>
                  <li v-if="item.keyword_tags && item.keyword_tags.length != 0">
                    <span>keyword_tags：</span
                    >{{ item.keyword_tags.join("，") }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="null_data" v-if="list.length == 0">没有数据</div>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="list"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
      />
    </div>
    <div class="null_page" v-else>没有操作权限</div>

    <!-- 文章数据详情 -->
    <el-dialog
      :title="artTitle"
      width="90%"
      :top="dialog_top"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <div class="art_detail">
        <pre>{{ artDetail }}</pre>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import time from "../../../assets/js/time.js";

export default {
  data() {
    return {
      isMagnify: false,
      loading: false,
      time,
      params: {},
      source: [{ site: "all", value: 0 }],
      form: {
        date: [],
        uDate: [],
        siteTypes: [],
        artTypes: [],
        domain: "",
        taskId: "",
        siteId: "",
        url: "",
        siteName: "",
        authorName: "",
        keyword: "",
        noKeyword: ""
      },
      conditionShow: true,

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      siteObj: {},
      sourceList: [], // 信源类型
      checkAll: false, // 是否全选

      list: [],
      total: 0,
      page: 1,
      pageSize: 25,
      tabIndex: 0,

      rules: {
        date: [{ required: true, message: "请选择时间", trigger: "blur" }],
        siteTypes: [
          { required: true, message: "请选择至少一个信源", trigger: "blur" }
        ]
      },
      changNum(num) {
        let new_num = num * 1;
        if (new_num >= 10000) new_num = (num / 10000).toFixed(2) + "万";
        return new_num;
      },

      dialogVisible: false,
      dialog_top: "5vh",
      artTitle: "数据详情",
      artDetail: null
    };
  },
  computed: {
    authority() {
      return this.$route.meta.authority;
    }
  },
  watch: {
    form: {
      deep: true,
      handler(e) {
        if (e.date == null) this.form.date = [];
        if (e.uDate == null) this.form.uDate = [];
      }
    }
  },
  created() {
    this.getSiteTypes();
  },
  mounted() {
    if (this.authority)
      this.$refs.list.addEventListener("scroll", this.listScroll);
  },
  methods: {
    // 获取列表数据
    getListData() {
      this.$refs.list.scrollTop = 0;
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.params));
      // 发表时间
      if (data.date.length != 0) {
        data.startDate = data.date[0];
        data.endDate = data.date[1];
      }
      // 入库时间
      if (data.uDate.length != 0) {
        data.startDateUtime = data.uDate[0];
        data.endDateUtime = data.uDate[1];
      }
      data.siteTypes = data.siteTypes.join(",");
      data.artTypes.length != 0
        ? (data.artTypes = data.artTypes.join(","))
        : (data.artTypes = "");
      data.pageIndex = this.page;
      data.pageSize = this.pageSize;
      delete data.date;
      delete data.uDate;

      this.$http({
        url: this.$api.search,
        data
      })
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.list = [];
            this.total = res.data.total;
            res.data.list.forEach(val => {
              val.show = false;
              if (val.pic_urls) {
                let imgs = val.pic_urls;
                let index1 = imgs.indexOf("[");
                if (index1 != -1) imgs = imgs.slice(index1 + 1);
                let index2 = imgs.indexOf("]");
                if (index2 != -1) imgs = imgs.slice(0, index2);
                val.picUrls = imgs.split(",");
              }
              this.list.push(val);
            });
            if (res.data.list.length == 0) this.$message("没有搜索到数据哦~");
          } else {
            this.list = [];
            this.total = 0;
            this.$hint(res.code + "-" + res.message, "err");
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 搜索
    search() {
      // 表单验证
      if (this.form.date.length == 0 && this.form.uDate.length == 0) {
        this.$hint("至少选择一个时间", "err");
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.page = 1;
          this.total = 0;
          this.list = [];
          this.params = JSON.parse(JSON.stringify(this.form));
          this.source = [{ site: "all", value: 0 }];
          this.params.siteTypes.forEach(val => {
            let obj = {
              site: val,
              value: 0
            };
            this.source.push(obj);
          });
          this.getListData();
        }
      });
    },
    // 获取所有信源
    getSiteTypes() {
      this.$http({
        url: this.$api.siteType,
        data: {}
      }).then(res => {
        if (res.code == 0) {
          this.siteObj = JSON.parse(JSON.stringify(res.data)) || {};
          this.siteObj.all = "全部";
          this.sourceList = [];
          Object.keys(res.data).forEach(key => {
            this.sourceList.push({
              id: key,
              name: res.data[key]
            });
          });
        }
      });
    },
    // 选择所有信源
    selectAll(val) {
      this.form.siteTypes = [];
      if (val) {
        this.sourceList.forEach(el => {
          this.form.siteTypes.push(el.id);
        });
      }
      this.checkAll = val;
    },
    // 选择某个信源
    selectSomeSource(data) {
      let checkedCount = data.length;
      this.checkAll = checkedCount === this.sourceList.length;
    },
    // 翻页
    changePage(e) {
      this.page = e;
      this.getListData();
    },
    // 点击查看更多
    lookMore(item) {
      item.show = !item.show;
    },
    // 打开文章数据详情
    openDet(item) {
      // window.open(url)
      this.dialogVisible = true;
      this.artDetail = item;
    },
    // 全屏
    switchMagnify() {
      this.isMagnify = !this.isMagnify;
    },
    // 监控列表滚动
    listScroll() {
      this.conditionShow = false;
    }
  }
};
</script>

<style lang="less" scoped>
.localQuery {
  width: 100%;
  height: calc(100vh - 100px);
  color: #525f7f;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  .head {
    width: 100%;
    padding: 10px 20px 5px;
    box-sizing: border-box;
    position: relative;
    border-bottom: 1px solid #e2e2e2;
    background: #f9f9f9;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    .form_item {
      display: flex;
      align-items: center;
      margin-bottom: 0px;
      .date_box {
        max-width: 400px;
        display: flex;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        background: #fff;
      }
      .checkboxDom {
        display: flex;
      }
    }
    .input_box {
      width: 100%;
      display: flex;
      align-items: center;
      margin-top: 5px;
      .form_item {
        flex: 1;
        display: flex;
        align-items: flex-start;
        margin-right: 10px;
      }
    }
    .type_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .btn {
        line-height: 30px;
        padding: 0 20px;
        font-size: 13px;
      }
    }
    .time_box {
      width: 100%;
      justify-content: flex-start;
      padding-right: 100px;
      box-sizing: border-box;

      .btn {
        margin-left: 20px;
      }
    }
    .word_box {
      justify-content: flex-start;
      margin-top: 10px;
      .form_item {
        flex: 1;
        margin-right: 10px;
      }
    }
    .formInput_box {
      display: flex;
      margin-top: 5px;
    }
    .form_url {
      width: 500px;
      margin-left: 10px;
      .url_input {
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        background: #fff;
      }
    }
    .show_btn {
      position: absolute;
      top: 0;
      right: 35px;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #525f7f;
      text-decoration: none;
      .iconfont {
        font-size: 12px;
        margin-left: 5px;
        display: inline-block;
        transform: translateY(1px) rotate(0deg);
        transition: all 0.5s;
      }
      .icon {
        transform: translateY(1px) rotate(180deg);
      }
    }
  }
  .tab {
    width: 100%;
    height: 35px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    border-top: 1px solid #e2e2e2;
    border-bottom: 1px solid #e2e2e2;
    > li {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      &::after {
        content: "";
        width: 1px;
        height: 14px;
        background: #e2e2e2;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &:nth-last-child(1) {
        &::after {
          content: none;
        }
      }
      > a {
        font-size: 12px;
        text-decoration: none;
        color: #666;
        white-space: nowrap;
      }
      .active {
        color: #525f7f;
        font-weight: bold;
      }
    }
  }
  .list_box {
    height: 0;
    flex: 1;
    overflow-y: auto;
    padding: 0 10px;
    box-sizing: border-box;
    > div {
      width: 100%;
      padding: 10px 10px 0 10px;
      box-sizing: border-box;
      display: flex;
      font-size: 13px;
      color: #525f7f;
      border-bottom: 1px solid #e2e2e2;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      &:nth-last-child(1) {
        border: none;
        box-shadow: none;
      }
      &:hover {
        background: #f9f9f9;
        .content {
          .more_btn {
            background: #f9f9f9;
          }
        }
      }
      .num {
        font-weight: bold;
        margin-right: 10px;
      }
      .weibo_num {
        font-weight: bold;
        margin-top: 10px;
        margin-right: 3px;
      }
      .art {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        .title {
          color: #525f7f;
          font-weight: bold;
          .tag {
            display: inline-block;
            padding: 0 5px;
            border-radius: 4px;
            background: #fef0f0;
            border: 1px solid #fde2e2;
            color: #f56c6c;
            font-weight: 500;
            box-sizing: border-box;
            margin-right: 5px;
            font-size: 12px;
            > span {
              display: inline-block;
              transform: scale(0.8);
            }
          }
          .tag2 {
            background: #ecf5ff;
            border: 1px solid #d9ecff;
            color: #409eff;
          }
          .tag3 {
            background: #fdf6ec;
            border: 1px solid #faecd8;
            color: #e6a23c;
          }
        }
        .content {
          width: 100%;
          line-height: 20px;
          font-size: 12px;
          margin: 5px 0 10px 0;
          position: relative;
          > div {
            width: 100%;
            color: #666;
            cursor: pointer;
            &:hover {
              color: #3297d3;
            }
          }
          .more_btn {
            position: absolute;
            right: 0;
            bottom: 0;
            z-index: 10;
            display: flex;
            align-items: center;
            font-size: 12px;
            padding: 0 12px;
            color: #3b4457;
            background: #fff;
            text-decoration: none;
            .iconfont {
              font-size: 12px;
              margin-left: 5px;
              display: inline-block;
              transform: translateY(1px) rotate(0deg);
              transition: all 0.5s;
            }
            .icon {
              transform: translateY(1px) rotate(180deg);
            }
          }
          .hidden_content {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .weibo_content {
          background: #f2f2f5;
          padding: 5px 10px;
          box-sizing: border-box;
          border-radius: 4px;
          .more_btn {
            right: 10px;
            bottom: 5px;
            background: #f2f2f5;
          }
        }
        .img_box {
          display: flex;
          flex-wrap: wrap;
          > li {
            width: 60px;
            height: 60px;
            border-radius: 4px;
            overflow: hidden;
            margin-right: 10px;
            margin-bottom: 10px;
            border: 1px solid #f1f1f1;
            display: flex;
            align-items: center;
            justify-content: center;
            &:nth-last-child(1) {
              margin-right: 0;
            }
            > img {
              width: 100%;
              height: auto;
            }
          }
        }
        .fn_box {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          font-size: 12px;
          color: #525f7f;
          > li {
            margin-right: 8px;
            margin-bottom: 10px;
            transform: scale(0.9);
            &:nth-child(1) {
              transform: scale(1);
            }
            &:nth-last-child(1) {
              margin-right: 0;
            }
            .iconfont {
              font-size: 13px;
            }
            > span {
              color: #999;
              display: inline-block;
            }
            > a {
              color: #409eff;
              font-size: 12px;
              transform: scale(0.9);
              display: inline-block;
            }
          }
        }
      }
      .weibo_art {
        display: flex;
        flex-direction: row;
        .head_img {
          margin: 0 10px;
          > img {
            width: 42px;
            height: 42px;
            border-radius: 50%;
          }
        }
        .weibo_style {
          width: 100%;
          display: flex;
          flex-direction: column;
        }
      }
    }
    .null_data {
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #c0c4cc;
      border: none;
      &:hover {
        background: transparent;
      }
    }
  }
  .paging_box {
    height: 50px;
    margin-top: 0;
    border-top: 1px solid #e2e2e2;
  }
  .magnify_box {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
    background: #525f7f;
    border-radius: 0 0 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    .suoxiao {
      transform: translateX(2px) translateY(-1px) scale(0.8);
    }
  }
}
.magnify {
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  width: 100vw;
  height: 100vh;
  z-index: 99;
}
.art_detail {
  height: 75vh;
  overflow: scroll;
  padding-bottom: 20px;
}
.art_detail::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 7px;
}

.art_detail::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 20px;
  background-color: #babfcc;
}

.art_detail::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: rgba(0, 0, 0, 0.05);
  border-radius: 20px;
}

/deep/.head {
  .el-form {
    width: 100%;
  }
  .el-form-item__label {
    font-size: 12px;
  }
  .el-form-item__content {
    line-height: 30px;
    flex: 1;
  }
  .el-select {
    width: 120px;
    background: rgba(231, 235, 241, 0.6);
  }
  .el-input__inner {
    height: 30px;
    line-height: 30px;
    border: none;
    background: transparent;
  }
  .el-input__icon {
    height: 30px;
    line-height: 30px;
  }
  .el-range-separator {
    height: 30px;
  }
  .el-checkbox-group {
    height: 30px;
  }
  .el-checkbox__label {
    font-size: 12px;
  }
  .el-checkbox {
    margin-right: 10px;
  }
  .el-textarea {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/localQuery.vue